import { render, staticRenderFns } from "./TarifariosIndex.vue?vue&type=template&id=7db08c28"
import script from "./TarifariosIndex.vue?vue&type=script&lang=js"
export * from "./TarifariosIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports